import { MapPin, Phone, Mail } from "lucide-react";
import { LOGO_URL } from "@/constants/site";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#0B3B39] text-[#FDFBF7] py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-start justify-between gap-12">
          <div className="flex items-center gap-4">
            <img src={LOGO_URL} alt="Resort The Forest logo" className="h-20 w-20 object-contain bg-[#FDFBF7] rounded-full p-1" />
            <div>
              <p className="font-serif-display text-2xl">Resort The Forest</p>
              <p className="text-xs uppercase tracking-[0.25em] text-[#C5A880] mt-1">A Forest Retreat</p>
            </div>
          </div>

          <div className="flex flex-col gap-4 text-sm">
            <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#C5A880]">Find Us</p>
            <a
              href="https://www.google.com/maps/place/The+forest/@26.7173211,88.7670645,19z/data=!4m6!3m5!1s0x39e4750067f95f4b:0x75682f3016bf1f50!8m2!3d26.7173208!4d88.7676731!16s%2Fg%2F11m63lm5vj"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-start gap-3 text-[#FDFBF7]/80 hover:text-[#C5A880] transition-colors duration-300"
              data-testid="footer-address"
            >
              <MapPin size={16} className="text-[#C5A880] mt-0.5 shrink-0" />
              <span>
                Near Gorumara National Park, Nutan Para,
                <br />
                Lataguri, West Bengal 735219
              </span>
            </a>
            <a href="tel:+919239645335" className="flex items-center gap-3 text-[#FDFBF7]/80 hover:text-[#C5A880] transition-colors duration-300" data-testid="footer-phone">
              <Phone size={16} className="text-[#C5A880]" /> +91 92396 45335
            </a>
            <a href="mailto:resorttheforest2026@gmail.com" className="flex items-center gap-3 text-[#FDFBF7]/80 hover:text-[#C5A880] transition-colors duration-300" data-testid="footer-email">
              <Mail size={16} className="text-[#C5A880]" /> resorttheforest2026@gmail.com
            </a>
          </div>

          <div className="flex flex-col gap-4">
            <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#C5A880]">Location</p>
            <iframe
              title="Resort The Forest on Google Maps"
              data-testid="footer-map"
              src="https://www.google.com/maps?q=26.7173208,88.7676731&z=15&output=embed"
              className="w-full md:w-72 h-44 border border-[#FDFBF7]/20 rounded-sm"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
            <a
              href="https://www.google.com/maps/place/The+forest/@26.7173211,88.7670645,19z/data=!4m6!3m5!1s0x39e4750067f95f4b:0x75682f3016bf1f50!8m2!3d26.7173208!4d88.7676731!16s%2Fg%2F11m63lm5vj"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="get-directions-link"
              className="text-xs uppercase tracking-[0.2em] font-semibold text-[#C5A880] hover:text-[#FDFBF7] transition-colors duration-300"
            >
              Get Directions &rarr;
            </a>
          </div>

          <div className="flex flex-col gap-4 text-sm">
            <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#C5A880]">Explore</p>
            <a href="#stays" className="text-[#FDFBF7]/80 hover:text-[#C5A880] transition-colors duration-300">Stays</a>
            <a href="#reserve" className="text-[#FDFBF7]/80 hover:text-[#C5A880] transition-colors duration-300">Reserve</a>
          </div>
        </div>

        <div className="border-t border-[#FDFBF7]/15 mt-14 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-[#FDFBF7]/60">© {new Date().getFullYear()} Resort The Forest. All rights reserved.</p>
          <p className="text-xs text-[#FDFBF7]/60">Families · Couples · Retreats · Travellers</p>
        </div>
      </div>
    </footer>
  );
};
